(function () {
  if (window.__bkDiscoverWizardInit) return;
  window.__bkDiscoverWizardInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var OPEN_HASH = '#taste-finder';
  var lastTrigger = null;

  // Usage events for Shopify customer events (web pixels) and GTM, when present.
  function track(action, data) {
    data = data || {};
    data.action = action;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('discover_wizard', data); } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push({ event: 'discover_wizard', discover_wizard: data }); } catch (e) {}
  }

  function currentPanel(wizard) {
    return wizard.querySelector('[data-wizard-step="products"]:not([hidden])');
  }

  function showStep(wizard, panel) {
    var steps = wizard.querySelectorAll('[data-wizard-step]');
    for (var i = 0; i < steps.length; i++) steps[i].hidden = true;
    panel.hidden = false;
    wizard.setAttribute('data-step', panel.getAttribute('data-wizard-step') === 'occasions' ? '1' : '2');
    var modal = wizard.closest('[data-wizard-modal]');
    if (modal) modal.scrollTop = 0;
    else if (wizard.getBoundingClientRect().top < 0) wizard.scrollIntoView({ block: 'start' });
  }

  function resetWizard(wizard) {
    showStep(wizard, wizard.querySelector('[data-wizard-step="occasions"]'));
  }

  function panelFor(tile) {
    var wizard = tile.closest('[data-discover-wizard]');
    return wizard && wizard.querySelector('[data-wizard-panel="' + tile.getAttribute('data-wizard-target') + '"]');
  }

  // Cards are fetched per occasion so the homepage does not carry all of them.
  function loadPanel(panel) {
    if (!panel || panel.dwLoading) return panel && panel.dwLoading;
    var list = panel.querySelector('[data-dw-src]');
    var error = panel.querySelector('.dw-load-error');
    panel.dwLoading = fetch(list.getAttribute('data-dw-src'), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        list.innerHTML = html;
        list.removeAttribute('aria-busy');
        error.hidden = true;
        renderMore(panel);
      })
      .catch(function () {
        panel.dwLoading = null;
        list.innerHTML = '';
        list.removeAttribute('aria-busy');
        error.hidden = false;
      });
    return panel.dwLoading;
  }

  // "Show me more ideas": the fragment carries the rest of the occasion's in-stock products,
  // hidden; each press reveals the next few.
  var MORE_STEP = 6;
  var MORE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M20 12a8 8 0 1 1-2.34-5.66M20 4v5h-5"/></svg>';

  function escapeHtml(text) {
    return String(text).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function renderMore(panel) {
    var wizard = panel.closest('[data-discover-wizard]');
    var list = panel.querySelector('[data-dw-src]');
    var box = panel.querySelector('.dw-more');
    if (!box) {
      box = document.createElement('div');
      box.className = 'dw-more';
      list.parentNode.insertBefore(box, list.nextSibling);
    }
    var hidden = list.querySelectorAll('[data-dw-extra][hidden]').length;
    var total = list.querySelectorAll('.dw-card').length;
    var seen = total - hidden;
    if (hidden > 0) {
      var next = Math.min(MORE_STEP, hidden);
      var label = next === 1 ? wizard.getAttribute('data-label-more-one') : wizard.getAttribute('data-label-more').replace('%n', next);
      var meta = wizard.getAttribute('data-label-seen').replace('%seen', seen).replace('%total', total);
      box.innerHTML = '<button type="button" class="dw-more-btn" data-dw-more>' + MORE_ICON + escapeHtml(label) + '</button>' +
        '<div class="dw-more-meta">' + escapeHtml(meta) + '<span class="dw-more-bar"><i style="width:' + Math.round(seen / total * 100) + '%"></i></span></div>';
    } else if (panel.dwMoreUsed) {
      var href = list.getAttribute('data-dw-src').split('?')[0];
      box.innerHTML = '<div class="dw-done"><strong>' + escapeHtml(wizard.getAttribute('data-label-done-title')) + '</strong>' +
        '<p>' + escapeHtml(wizard.getAttribute('data-label-done-text')) + '</p>' +
        '<a href="' + escapeHtml(href) + '">' + escapeHtml(wizard.getAttribute('data-label-see-all')) + ' &rarr;</a></div>';
    } else {
      box.innerHTML = '';
    }
  }

  function showMore(button) {
    var panel = button.closest('[data-wizard-panel]');
    var wizard = panel.closest('[data-discover-wizard]');
    var extras = panel.querySelectorAll('[data-dw-extra][hidden]');
    var first = null;
    for (var i = 0; i < extras.length && i < MORE_STEP; i++) {
      var card = extras[i];
      card.hidden = false;
      var img = card.querySelector('.dw-card-img');
      if (img && !img.querySelector('.dw-new')) {
        var badge = document.createElement('span');
        badge.className = 'dw-new';
        badge.textContent = wizard.getAttribute('data-label-new');
        img.insertBefore(badge, img.firstChild);
      }
      if (!first) first = card;
    }
    panel.dwMoreUsed = true;
    renderMore(panel);
    track('more_ideas', { occasion: panel.getAttribute('data-occasion') });
    if (first) {
      first.scrollIntoView({ block: 'start', behavior: 'smooth' });
      var link = first.querySelector('.dw-card-name');
      if (link) link.focus({ preventScroll: true });
    }
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function setModalOpen(modal, open) {
    // #PageContainer carries a transform, which pins position:fixed to it instead of the viewport.
    if (open && modal.parentElement !== document.body) document.body.appendChild(modal);
    modal.classList.toggle('is-open', open);
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('discover-wizard-modal-open', open);
    var wizard = modal.querySelector('[data-discover-wizard]');
    if (!wizard) return;
    if (open) {
      var close = wizard.querySelector('.dw-close');
      if (close) close.focus({ preventScroll: true });
      track('open');
      // Something may have been added elsewhere on the page since it loaded.
      getCart().then(function (cart) {
        var counts = wizard.querySelectorAll('[data-dw-count]');
        for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;
      }).catch(function () {});
    } else {
      resetWizard(wizard);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    }
  }

  // Open the popup if this page has one; otherwise scroll to an inline wizard, or go to the dedicated page.
  function openFirstModal(trigger) {
    var modal = document.querySelector('[data-wizard-modal]');
    if (modal) {
      lastTrigger = trigger || null;
      setModalOpen(modal, true);
      return true;
    }
    var inline = document.querySelector('.dw-inline [data-discover-wizard]');
    if (inline) {
      inline.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return true;
    }
    location.href = root + 'pages/taste-finder';
    return true;
  }

  function selectOccasion(wizard, tile) {
    var panel = panelFor(tile);
    if (!panel) return;
    panel.setAttribute('data-occasion', tile.getAttribute('data-occasion'));
    showStep(wizard, panel);
    loadPanel(panel);
    panel.dwFromTile = tile;
    var back = panel.querySelector('.dw-back');
    if (back) back.focus({ preventScroll: true });
    track('pick_occasion', { occasion: tile.getAttribute('data-occasion') });
  }

  function updateCounts(count) {
    var counts = document.querySelectorAll('[data-dw-count], [data-cart-count]');
    for (var i = 0; i < counts.length; i++) counts[i].textContent = count;
    var bubble = document.getElementById('CartCount');
    if (bubble) bubble.classList.toggle('hide', count === 0);
    var baskets = document.querySelectorAll('.dw-basket');
    for (var j = 0; j < baskets.length; j++) {
      baskets[j].removeAttribute('data-bump');
      void baskets[j].offsetWidth;
      baskets[j].setAttribute('data-bump', '');
    }
  }

  // Mark the cart so the order shows which products came from the Taste Finder (order page,
  // "Additional details"; a Shopify Flow rule can tag those orders). /cart/update.js only changes
  // the attribute keys it is sent, so the other apps' cart attributes are left untouched.
  var CART_ATTRIBUTE = 'Taste Finder';
  function markCart(cart, title) {
    if (!title) return;
    var current = (cart.attributes && cart.attributes[CART_ATTRIBUTE]) || '';
    var items = current ? current.split(' | ') : [];
    if (items.indexOf(title) !== -1) return;
    items.push(title);
    var value = items.join(' | ');
    if (value.length > 1000) return;
    var attributes = {};
    attributes[CART_ATTRIBUTE] = value;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  function showMessage(button, text) {
    var msg = button.closest('.dw-card-body').querySelector('.dw-msg');
    msg.textContent = text;
    msg.hidden = !text;
  }

  // /cart/add.js does not enforce stock, so check what is already in the cart first,
  // the same way the product page does (see _getCartItems in theme.js).
  function addToCart(button) {
    var wizard = button.closest('[data-discover-wizard]');
    var id = button.getAttribute('data-dw-add');
    var variantId = Number(id);
    var max = button.hasAttribute('data-max') ? Number(button.getAttribute('data-max')) : Infinity;
    var panel = button.closest('[data-wizard-panel]');
    // The same product can sit in several occasions; lock every button for it until this add settles.
    var siblings = document.querySelectorAll('[data-dw-add="' + id + '"]');
    for (var i = 0; i < siblings.length; i++) siblings[i].disabled = true;
    showMessage(button, '');

    getCart().then(function (cart) {
      var inCart = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === variantId) inCart += cart.items[i].quantity;
      }
      if (inCart >= max) throw { max: true };
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(
          function (body) { throw { message: body && body.description }; },
          function () { throw {}; }
        );
      }
      return getCart();
    }).then(function (cart) {
      updateCounts(cart.item_count);
      markCart(cart, button.getAttribute('data-product-title'));
      track('add_to_cart', { occasion: panel && panel.getAttribute('data-occasion'), variant_id: variantId, product: button.getAttribute('data-product-title') });
      button.setAttribute('data-added', '');
      button.textContent = wizard.getAttribute('data-label-added');
      setTimeout(function () {
        button.removeAttribute('data-added');
        button.textContent = wizard.getAttribute('data-label-add');
      }, 1500);
    }).catch(function (err) {
      err = err || {};
      showMessage(button, err.max ? wizard.getAttribute('data-label-max') : (err.message || wizard.getAttribute('data-label-error')));
    }).then(function () {
      for (var i = 0; i < siblings.length; i++) siblings[i].disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-wizard-target]');
    if (tile) {
      // Let modified clicks open the collection in a new tab, like any link.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      selectOccasion(tile.closest('[data-discover-wizard]'), tile);
      return;
    }

    // Banner cards jump straight into their occasion: in the popup on the homepage, in place on the page.
    var jump = e.target.closest('[data-dw-jump]');
    if (jump) {
      var scope = jump.getAttribute('data-dw-scope');
      var jumpModal = document.querySelector('[data-wizard-modal="' + scope + '"]');
      var jumpWizard;
      if (jumpModal) {
        lastTrigger = jump;
        setModalOpen(jumpModal, true);
        jumpWizard = jumpModal.querySelector('[data-discover-wizard]');
      } else {
        jumpWizard = document.querySelector('#shopify-section-' + scope + ' [data-discover-wizard]');
      }
      var jumpTile = jumpWizard && jumpWizard.querySelector('[data-wizard-target="' + jump.getAttribute('data-dw-jump') + '"]');
      if (jumpTile) {
        selectOccasion(jumpWizard, jumpTile);
        if (!jumpModal) jumpWizard.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      return;
    }

    var backBtn = e.target.closest('[data-wizard-back]');
    if (backBtn) {
      var w = backBtn.closest('[data-discover-wizard]');
      var open = currentPanel(w);
      var from = open && open.dwFromTile;
      resetWizard(w);
      if (from) from.focus({ preventScroll: true });
      return;
    }

    var more = e.target.closest('[data-dw-more]');
    if (more) {
      showMore(more);
      return;
    }

    var add = e.target.closest('[data-dw-add]');
    if (add) {
      if (!add.disabled) addToCart(add);
      return;
    }

    var trigger = e.target.closest('[data-wizard-modal-trigger]');
    if (trigger) {
      var modal = document.querySelector('[data-wizard-modal="' + trigger.getAttribute('data-wizard-modal-trigger') + '"]');
      if (modal) {
        lastTrigger = trigger;
        setModalOpen(modal, true);
      }
      return;
    }

    // Any link to #taste-finder (a banner, the menu, an email) opens the popup.
    var hashLink = e.target.closest('a[href$="' + OPEN_HASH + '"]');
    if (hashLink && openFirstModal(hashLink)) {
      e.preventDefault();
      return;
    }

    var close = e.target.closest('[data-wizard-modal-close]');
    if (close) {
      var openModal = close.closest('[data-wizard-modal]');
      if (openModal) setModalOpen(openModal, false);
    }
  });

  // Start fetching an occasion's products as soon as a finger or pointer lands on its tile.
  function prefetch(e) {
    var target = e.target.closest && e.target.closest('[data-wizard-target], [data-dw-jump]');
    if (!target) return;
    if (target.hasAttribute('data-wizard-target')) return loadPanel(panelFor(target));
    var panel = document.querySelector('[data-wizard-panel="' + target.getAttribute('data-dw-jump') + '"]');
    if (panel) loadPanel(panel);
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  document.addEventListener('keydown', function (e) {
    var openModals = document.querySelectorAll('[data-wizard-modal].is-open');
    if (!openModals.length) return;
    if (e.key === 'Escape') {
      for (var i = 0; i < openModals.length; i++) setModalOpen(openModals[i], false);
      return;
    }
    // Keep Tab inside the popup.
    if (e.key !== 'Tab') return;
    var dialog = openModals[openModals.length - 1].querySelector('.discover-wizard-modal__dialog');
    var focusable = [].filter.call(dialog.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      return el.offsetParent !== null && el.tabIndex !== -1;
    });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      e.preventDefault(); first.focus();
    }
  });

  // Theme editor: the popup lives under <body> once opened, so a section re-render would leave it behind.
  document.addEventListener('shopify:section:unload', function (e) {
    var stale = document.querySelector('body > [data-wizard-modal="' + e.detail.sectionId + '"]');
    if (stale) {
      stale.parentNode.removeChild(stale);
      document.body.classList.remove('discover-wizard-modal-open');
    }
  });

  function openFromHash() {
    if (location.hash === OPEN_HASH) openFirstModal(null);
  }
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash);
  else openFromHash();
})();
